webpackJsonp([21],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/rEA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("OMN4");

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _localStorageFallback = __webpack_require__("URp7");

var _localStorageFallback2 = _interopRequireDefault(_localStorageFallback);

var _msg = __webpack_require__("L8QK");

var _auth = __webpack_require__("TIfe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTokenFromLocalStorage() {
  try {
    var sessionString = _localStorageFallback2.default.getItem('sp_session');
    if (!sessionString) {
      return null;
    }

    var session = JSON.parse(sessionString);
    return session && session.access_token || null;
  } catch (e) {
    return null;
  }
}

var service = _axios2.default.create({
  baseURL: location.hostname.indexOf('yihulu.com') > -1 ? "https://lbx.api.yihulu.com/api/v1" : "https://api.lebaoxiu.com/api/v1",
  timeout: 25000 });

service.interceptors.request.use(function (config) {
  var token = _store2.default.getters.token || getTokenFromLocalStorage();
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
}, function (error) {
  Promise.reject(error);
});

service.interceptors.response.use(function (response) {
  if (response.data) {
    if (response.data.error_code !== 0) {
      return {
        biz_code: 1,
        biz_message: response.data.message || '发生了错误'
      };
    }
  }
  return response.data.result;
}, function (error) {
  if (error && error.response) {
    if (error.response.status === 401) {
      (0, _msg.showError)('无权限操作');
      layer && layer.closeAll();
      (0, _auth.logoutAndShowLogin)();
      return {
        biz_code: 1,
        biz_message: '无权限操作'
      };
    }

    if (error.response.status === 429) {
      (0, _msg.showError)('您的操作太频繁了, 请休息一会后继续操作');
      return {
        biz_code: 1,
        biz_message: '您的操作太频繁了, 请休息一会后继续操作'
      };
    }

    switch (error.response.status) {
      case 400:
        error.message = '错误请求';
        break;
      case 401:
        error.message = '未授权，请重新登录';
        break;
      case 403:
        error.message = '拒绝访问';
        break;
      case 404:
        error.message = '请求错误,未找到该资源';
        break;
      case 405:
        error.message = '请求方法未允许';
        break;
      case 408:
        error.message = '请求超时';
        break;
      case 429:
        error.message = '您的操作太频繁了, 请休息一会后继续操作';
        break;
      case 500:
        error.message = '服务器端出错';
        break;
      case 501:
        error.message = '网络未实现';
        break;
      case 502:
        error.message = '网络错误';
        break;
      case 503:
        error.message = '服务不可用';
        break;
      case 504:
        error.message = '网络超时';
        break;
      case 505:
        error.message = 'http版本不支持该请求';
        break;
      default:
        error.message = '\u8FDE\u63A5\u9519\u8BEF' + error.response.status;
    }
  } else {
    error.message = "连接到服务器失败";
  }

  (0, _msg.showError)(error.message);

  return Promise.reject(error);
});

exports.default = service;

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0iPh":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "2U+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loader"},[_c('div',{staticClass:"page-loader__spinner"},[_c('svg',{attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"20","fill":"none","strokeWidth":"2","strokeMiterlimit":"10"}})])])])}
var staticRenderFns = []


/***/ }),

/***/ "5cs8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  mounted: function mounted() {
    var pageLoader = document.getElementsByClassName('page-loader')[0];
    pageLoader.classList.add('animated');
    pageLoader.classList.add('fadeOut');
    setTimeout(function () {
      pageLoader.style.display = 'none';
    }, 200);
  }
};

/***/ }),

/***/ "6KT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("QYRB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38376abd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("V2wM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fEJJ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38376abd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38376abd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8x0Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var APP_EDITIONS = ['试用版', '基础版', '高级版'];
var EDITION_PRICE = {
  0: 0,
  1: 360,
  2: 980
};

exports.APP_EDITIONS = APP_EDITIONS;
exports.EDITION_PRICE = EDITION_PRICE;

/***/ }),

/***/ "9MZt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _waves = __webpack_require__("0mzn");

var _waves2 = _interopRequireDefault(_waves);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_waves2.default.init();

var vueWaves = {};

vueWaves.install = function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { name: 'waves' };

  Vue.directive(options.name, {
    inserted: function inserted(el, binding) {
      _waves2.default.attach(el);
    },
    unbind: function unbind(el) {
      _waves2.default.calm(el);
    }
  });
};

exports.default = vueWaves;

/***/ }),

/***/ "AFp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AyJ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.a1f4f70.jpg";

/***/ }),

/***/ "Du/2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_SIDEBAR = exports.TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var REQUEST_INVITE_INFO = exports.REQUEST_INVITE_INFO = 'REQUEST_INVITE_INFO';
var RECEIVE_INVITE_INFO = exports.RECEIVE_INVITE_INFO = 'RECEIVE_INVITE_INFO';

var REQUEST_SP_INFO = exports.REQUEST_SP_INFO = 'REQUEST_SP_INFO';
var RECEIVE_SP_INFO = exports.RECEIVE_SP_INFO = 'RECEIVE_SP_INFO';
var REQUEST_SAVE_SP_INFO = exports.REQUEST_SAVE_SP_INFO = 'REQUEST_SAVE_SP_INFO';
var RECEIVE_SAVE_SP_INFO = exports.RECEIVE_SAVE_SP_INFO = 'RECEIVE_SAVE_SP_INFO';

var UPDATE_INFO_NAME = exports.UPDATE_INFO_NAME = 'UPDATE_INFO_NAME';
var UPDATE_INFO_CONTACTOR = exports.UPDATE_INFO_CONTACTOR = 'UPDATE_INFO_CONTACTOR';

var UPDATE_WECHAT_APP_ID = exports.UPDATE_WECHAT_APP_ID = 'UPDATE_WECHAT_APP_ID';
var UPDATE_WECHAT_APP_SECRET = exports.UPDATE_WECHAT_APP_SECRET = 'UPDATE_WECHAT_APP_SECRET';
var UPDATE_WECHAT_ENCODING_AES_KEY = exports.UPDATE_WECHAT_ENCODING_AES_KEY = 'UPDATE_WECHAT_ENCODING_AES_KEY';

var REQUEST_WECHAT_INFO = exports.REQUEST_WECHAT_INFO = 'REQUEST_WECHAT_INFO';
var RECEIVE_WECHAT_INFO = exports.RECEIVE_WECHAT_INFO = 'RECEIVE_WECHAT_INFO';
var REQUEST_SAVE_WECHAT_INFO = exports.REQUEST_SAVE_WECHAT_INFO = 'REQUEST_SAVE_WECHAT_INFO';
var RECEIVE_SAVE_WECHAT_INFO = exports.RECEIVE_SAVE_WECHAT_INFO = 'RECEIVE_SAVE_WECHAT_INFO';

var REQUEST_WECHAT_CLEAR_SETTING = exports.REQUEST_WECHAT_CLEAR_SETTING = 'REQUEST_WECHAT_CLEAR_SETTING';
var RECEIVE_WECHAT_CLEAR_SETTING = exports.RECEIVE_WECHAT_CLEAR_SETTING = 'RECEIVE_WECHAT_CLEAR_SETTING';

var REQUEST_FORM_LIST = exports.REQUEST_FORM_LIST = 'REQUEST_FORM_LIST';
var RECEIVE_FORM_LIST = exports.RECEIVE_FORM_LIST = 'RECEIVE_FORM_LIST';
var REQUEST_SHARED_FORM_LIST = exports.REQUEST_SHARED_FORM_LIST = 'REQUEST_SHARED_FORM_LIST';
var RECEIVE_SHARED_FORM_LIST = exports.RECEIVE_SHARED_FORM_LIST = 'RECEIVE_SHARED_FORM_LIST';
var REQUEST_SAVE_FORM_INFO = exports.REQUEST_SAVE_FORM_INFO = 'REQUEST_SAVE_FORM_INFO';
var RECEIVE_SAVE_FORM_INFO = exports.RECEIVE_SAVE_FORM_INFO = 'RECEIVE_SAVE_FORM_INFO';
var REQUEST_FORM_INFO = exports.REQUEST_FORM_INFO = 'REQUEST_FORM_INFO';
var RECEIVE_FORM_INFO = exports.RECEIVE_FORM_INFO = 'RECEIVE_FORM_INFO';
var REQUEST_DEFAULT_FORM_INFO = exports.REQUEST_DEFAULT_FORM_INFO = 'REQUEST_DEFAULT_FORM_INFO';
var RECEIVE_DEFAULT_FORM_INFO = exports.RECEIVE_DEFAULT_FORM_INFO = 'RECEIVE_DEFAULT_FORM_INFO';

var REQUEST_MY_TICKET_LIST = exports.REQUEST_MY_TICKET_LIST = 'REQUEST_MY_TICKET_LIST';
var RECEIVE_MY_TICKET_LIST = exports.RECEIVE_MY_TICKET_LIST = 'RECEIVE_MY_TICKET_LIST';

var REQUEST_TICKET_DETAIL = exports.REQUEST_TICKET_DETAIL = 'REQUEST_TICKET_DETAIL';
var RECEIVE_TICKET_DETAIL = exports.RECEIVE_TICKET_DETAIL = 'RECEIVE_TICKET_DETAIL';

var REQUEST_CHANGE_PASSWORD = exports.REQUEST_CHANGE_PASSWORD = 'REQUEST_CHANGE_PASSWORD';
var RECEIVE_CHANGE_PASSWORD = exports.RECEIVE_CHANGE_PASSWORD = 'RECEIVE_CHANGE_PASSWORD';

var REQUEST_CREATE_WECHAT_MENU = exports.REQUEST_CREATE_WECHAT_MENU = 'REQUEST_CREATE_WECHAT_MENU';
var RECEIVE_CREATE_WECHAT_MENU = exports.RECEIVE_CREATE_WECHAT_MENU = 'RECEIVE_CREATE_WECHAT_MENU';

var REQUEST_FETCH_WECHAT_MENU = exports.REQUEST_FETCH_WECHAT_MENU = 'REQUEST_FETCH_WECHAT_MENU';
var RECEIVE_FETCH_WECHAT_MENU = exports.RECEIVE_FETCH_WECHAT_MENU = 'RECEIVE_FETCH_WECHAT_MENU';

var REQUEST_BIND_YHL_TEAM = exports.REQUEST_BIND_YHL_TEAM = 'REQUEST_BIND_YHL_TEAM';
var RECEIVE_BIND_YHL_TEAM = exports.RECEIVE_BIND_YHL_TEAM = 'RECEIVE_BIND_YHL_TEAM';

var REQUEST_APPLY_SUB_DOMAIN = exports.REQUEST_APPLY_SUB_DOMAIN = 'REQUEST_APPLY_SUB_DOMAIN';
var RECEIVE_APPLY_SUB_DOMAIN = exports.RECEIVE_APPLY_SUB_DOMAIN = 'RECEIVE_APPLY_SUB_DOMAIN';

var REQUEST_SUBDOMAIN_LIST = exports.REQUEST_SUBDOMAIN_LIST = 'REQUEST_SUBDOMAIN_LIST';
var RECEIVE_SUBDOMAIN_LIST = exports.RECEIVE_SUBDOMAIN_LIST = 'RECEIVE_SUBDOMAIN_LIST';

var REQUEST_ACCOUNT_INFO = exports.REQUEST_ACCOUNT_INFO = 'REQUEST_ACCOUNT_INFO';
var RECEIVE_ACCOUNT_INFO = exports.RECEIVE_ACCOUNT_INFO = 'RECEIVE_ACCOUNT_INFO';

var REQUEST_ACCOUNT_RENEW = exports.REQUEST_ACCOUNT_RENEW = 'REQUEST_ACCOUNT_RENEW';
var RECEIVE_ACCOUNT_RENEW = exports.RECEIVE_ACCOUNT_RENEW = 'RECEIVE_ACCOUNT_RENEW';

var REQUEST_ACCOUNT_SZ_LIST = exports.REQUEST_ACCOUNT_SZ_LIST = 'REQUEST_ACCOUNT_SZ_LIST';
var RECEIVE_ACCOUNT_SZ_LIST = exports.RECEIVE_ACCOUNT_SZ_LIST = 'RECEIVE_ACCOUNT_SZ_LIST';

var REQUEST_SP_LIST = exports.REQUEST_SP_LIST = 'REQUEST_SP_LIST';
var RECEIVE_SP_LIST = exports.RECEIVE_SP_LIST = 'RECEIVE_SP_LIST';

var REQUEST_SP_SETTING = exports.REQUEST_SP_SETTING = 'REQUEST_SP_SETTING';
var RECEIVE_SP_SETTING = exports.RECEIVE_SP_SETTING = 'RECEIVE_SP_SETTING';

var REQUEST_SAVE_SP_SETTING = exports.REQUEST_SAVE_SP_SETTING = 'REQUEST_SAVE_SP_SETTING';
var RECEIVE_SAVE_SP_SETTING = exports.RECEIVE_SAVE_SP_SETTING = 'RECEIVE_SAVE_SP_SETTING';

var REQUEST_FETCH_AUTHORIZER_LIST = exports.REQUEST_FETCH_AUTHORIZER_LIST = 'REQUEST_FETCH_AUTHORIZER_LIST';
var RECEIVE_FETCH_AUTHORIZER_LIST = exports.RECEIVE_FETCH_AUTHORIZER_LIST = 'RECEIVE_FETCH_AUTHORIZER_LIST';

var REQUEST_SERVICE_TICKET_DETAIL = exports.REQUEST_SERVICE_TICKET_DETAIL = 'REQUEST_SERVICE_TICKET_DETAIL';
var RECEIVE_SERVICE_TICKET_DETAIL = exports.RECEIVE_SERVICE_TICKET_DETAIL = 'RECEIVE_SERVICE_TICKET_DETAIL';

var REQUEST_FETCH_TICKET_STEPS = exports.REQUEST_FETCH_TICKET_STEPS = 'REQUEST_FETCH_TICKET_STEPS';
var RECEIVE_FETCH_TICKET_STEPS = exports.RECEIVE_FETCH_TICKET_STEPS = 'RECEIVE_FETCH_TICKET_STEPS';

var REQUEST_RM_LIST = exports.REQUEST_RM_LIST = 'REQUEST_RM_LIST';
var RECEIVE_RM_LIST = exports.RECEIVE_RM_LIST = 'RECEIVE_RM_LIST';

/***/ }),

/***/ "E3IV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_loading_vue__ = __webpack_require__("5cs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_loading_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_loading_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_loading_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430a4494_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_loading_vue__ = __webpack_require__("2U+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("AFp4")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_loading_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430a4494_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_loading_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_430a4494_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_loading_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("lRwf");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("SJI6");

var _vuex2 = _interopRequireDefault(_vuex);

var _getters = __webpack_require__("UjVw");

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__("ukYY");

var _mutations2 = _interopRequireDefault(_mutations);

var _actions = __webpack_require__("mUbh");

var _actions2 = _interopRequireDefault(_actions);

var _auth = __webpack_require__("TIfe");

var _helper = __webpack_require__("VSB1");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var jwt = (0, _auth.getAuthInfo)() || {};

var state = {
  topbarVisible: (0, _helper.getQueryString)('hidetopbar') !== '1',
  sidebarVisible: (0, _helper.getQueryString)('hideleftbar') !== '1',
  token: jwt.access_token,
  user: {
    name: jwt.preferred_username || '用户名',
    sp_id: jwt.sp_id,
    sp_name: jwt.sp_name || '服务商名称',
    avatar: jwt.avatar,
    sp_contactor: jwt.sp_contactor
  },
  invite: {
    loading: true,
    qrcode: null,
    reportqrcodes: [],
    url: null,
    reporturls: '',
    home_page_url: '',
    is_apply_sub_domain: false,
    sub_domain_name: '',
    sub_domain_status: 0,
    is_apply_own_domain: false,
    own_domain_name: '',
    own_domain_status: 0
  },
  info: {
    saving: false,
    loading: false,
    name: '',
    contactor: '',
    contact_phone: '',
    email: '',
    address: '',
    about_content: '',
    sub_domain: '',
    yhl_team_name: '',
    yhl_team_id: '',
    yhl_branch_id: null,
    active_edition: '试用版',
    expire_date: null,
    logo: null,
    spec: 0,
    left_days: 0,
    login_account: '',
    use_we_chat_third_party_platform: true,
    bind_sys_code: null
  },
  wechat: {
    saving: false,
    loading: false,
    app_id: '',
    app_secret: '',
    encoding_aes_key: '',
    token: '',
    server_ip: '',
    callback_url: '',
    verified_domain: '',
    is_empty: true,
    qr_code: '',
    is_template_message_enabled: false,
    transfer_message_to_kf_system: false,
    ticket_progress_changed_template_id: null
  },
  wechat_menu: {
    saving: false,
    loading: false,
    menu: {}
  },
  form: {
    df_loading: false,
    df: {},
    loading: false,
    saving: false,
    list: [],
    total: 0,
    shared_list: [],
    shared_total: 0
  },
  report_list: {
    loading: false,
    columns: [],
    data: [],
    additional_parameters: {},
    total: 0
  },
  report_detail: {
    loading: false,
    ticket: null,
    no: '',
    videos: [],
    voices: [],
    attachments: [],
    service_ticket: null,
    service_ticket_loaded: false
  },
  report_steps: {
    querying: false,
    steps: [],
    current: 0
  },
  sub_domain_list: {
    loading: false,
    data: [],
    total: 0
  },
  account_info: {
    loading: false,
    list_loading: false,
    spec: 0,
    can_renew_service: false,
    can_upgrade_edition: false,
    active_edition: '试用版',
    expire_date: null,
    left_days: 0,
    list_data: [],
    list_total: 0
  },
  sp_list: {
    loading: false,
    data: [],
    total: 0
  },
  setting: {
    loading: false,
    saving: false,
    setting: null
  },
  repair_member_list: {
    loading: false,
    data: [],
    total: 0
  }
};

exports.default = new _vuex2.default.Store({
  state: state,
  getters: _getters2.default,
  mutations: _mutations2.default,
  actions: _actions2.default
});

/***/ }),

/***/ "L8QK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__("cwe7");

var _message2 = _interopRequireDefault(_message);

var _message3 = __webpack_require__("2X9z");

var _message4 = _interopRequireDefault(_message3);

exports.showInfo = showInfo;
exports.showSuccess = showSuccess;
exports.showWarn = showWarn;
exports.showError = showError;

__webpack_require__("+BTi");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function showInfo(message) {
  (0, _message4.default)({
    message: message
  });
}

function showSuccess(message) {
  (0, _message4.default)({
    message: message,
    type: 'success'
  });
}

function showWarn(message) {
  (0, _message4.default)({
    message: message,
    type: 'warning'
  });
}

function showError(message) {
  _message4.default.error(message);
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _errorEmitter = __webpack_require__("ldce");

var _errorEmitter2 = _interopRequireDefault(_errorEmitter);

var _vue = __webpack_require__("lRwf");

var _vue2 = _interopRequireDefault(_vue);

var _vuexRouterSync = __webpack_require__("9JMe");

__webpack_require__("d6Iv");

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

__webpack_require__("UrHU");

__webpack_require__("Uibd");

var _vueWaves = __webpack_require__("9MZt");

var _vueWaves2 = _interopRequireDefault(_vueWaves);

var _vueStickyDirective = __webpack_require__("hNdr");

var _vueStickyDirective2 = _interopRequireDefault(_vueStickyDirective);

var _filters = __webpack_require__("Q0Ca");

var filters = _interopRequireWildcard(_filters);

var _layout = __webpack_require__("6KT8");

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_errorEmitter2.default.install();

_vue2.default.use(_vueWaves2.default);

_vue2.default.use(_vueStickyDirective2.default);

Object.keys(filters).forEach(function (key) {
  _vue2.default.filter(key, filters[key]);
});

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

_vue2.default.config.productionTip = false;

if (false) {
  _vue2.default.config.devtools = true;
  _vue2.default.config.performance = true;
} else {
  _vue2.default.config.errorHandler = function (err, vm, info) {
    _errorEmitter2.default.report({
      source: 'vue',
      err: err,
      vm: vm,
      info: info
    });
  };
}

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<Layout/>',
  components: { Layout: _layout2.default }
});

/***/ }),

/***/ "OMN4":
/***/ (function(module, exports) {

module.exports = axios;

/***/ }),

/***/ "Owz1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_trigger_vue__ = __webpack_require__("hOf8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_trigger_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_trigger_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_trigger_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_trigger_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c690290_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_trigger_vue__ = __webpack_require__("i3Wq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Yd1y")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navigation_trigger_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c690290_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_trigger_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c690290_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navigation_trigger_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Q0Ca":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.formatUtcTicks = formatUtcTicks;
exports.yhlThumb = yhlThumb;

var _helper = __webpack_require__("VSB1");

function formatDate(date, format) {
  if (!date) {
    return '-';
  }
  return (0, _helper.date_format)(date, format);
}

function formatUtcTicks(ticks, format) {
  if (!ticks) {
    return '';
  }
  var t = new Date(ticks);
  var utc = new Date(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds());
  if (!format) {
    format = "yyyy-MM-dd hh:mm:ss";
  }
  try {
    return formatDate(utc, format);
  } catch (e) {
    return "Invalid Date";
  }
}

function yhlThumb(url) {
  if (!url) return "../img/none.jpg";
  if (url === "/public/images/none.jpg") {
    url = "../img/none.jpg";
  }
  return url;
}

/***/ }),

/***/ "QYRB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vuex = __webpack_require__("SJI6");

var _appLoading = __webpack_require__("E3IV");

var _appLoading2 = _interopRequireDefault(_appLoading);

var _appHeader = __webpack_require__("Yupf");

var _appHeader2 = _interopRequireDefault(_appHeader);

var _appSidebar = __webpack_require__("fjsk");

var _appSidebar2 = _interopRequireDefault(_appSidebar);

var _navigationTrigger = __webpack_require__("Owz1");

var _navigationTrigger2 = _interopRequireDefault(_navigationTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { AppLoading: _appLoading2.default, AppHeader: _appHeader2.default, AppSidebar: _appSidebar2.default, NavigationTrigger: _navigationTrigger2.default },
  data: function data() {
    return {};
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['topbarVisible', 'sidebarVisible'])),
  watch: {},
  methods: _extends({}, (0, _vuex.mapActions)(['fetchSpInfo'])),
  beforeCreated: function beforeCreated() {},
  created: function created() {},
  mounted: function mounted() {
    if (!this.topbarVisible) {
      this.fetchSpInfo().catch(function () {});
    }
  }
};

/***/ }),

/***/ "SJI6":
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),

/***/ "SMMp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vuex = __webpack_require__("SJI6");

var _auth = __webpack_require__("TIfe");

exports.default = {
  components: {},
  data: function data() {
    var _this = this;

    return {
      showUserDropDownMenu: false,
      menus: [{ to: { name: 'Dashboard' }, icon: 'zmdi zmdi-home', label: '工作台' }, { to: { name: 'Tickets' }, icon: 'zmdi zmdi-view-list', label: '报修单' }, { to: { name: 'RepairMember' }, icon: 'zmdi zmdi-accounts', label: '报修会员' }, { to: { name: 'RepairForm' }, icon: 'zmdi zmdi-check-square', label: '报修表单' }, { to: { name: 'RepairTemplate' }, icon: 'zmdi zmdi-widgets', label: '报修模板' }, {
        label: '微信公众号',
        icon: 'zmdi zmdi-center-focus-strong',
        prefix: '/wechat',
        toggled: false,
        show: function show() {
          return false;
        },
        sub_menus: [{ to: { name: 'WeChat' }, label: '配置' }, { to: { name: 'WeChatMenuOld' }, label: '公众号菜单' }, { to: { name: 'WeChatSubscribeReply' }, label: '关注回复' }]
      }, {
        label: '微信授权公众号',
        icon: 'zmdi zmdi-center-focus-strong',
        prefix: '/authorizer',
        toggled: false,
        show: function show() {
          return true;
        },
        sub_menus: [{ to: { name: 'WeChatAuthorizerMenu' }, label: '授权公众号列表' }, { to: { name: 'WeChatMenu' }, label: '公众号菜单' }]
      }, {
        to: { name: 'Binding' },
        icon: 'zmdi zmdi-8tracks',
        label: '系统集成',
        toggled: false,
        show: function show() {
          return +_this.info_spec === 2 || +_this.info_spec === 0;
        }
      }, { to: { name: 'AccountInfo' }, icon: 'zmdi zmdi-money', label: '我的账户' }, { to: { name: 'SpInfo' }, icon: 'zmdi zmdi-account', label: '我的信息' }, { to: { name: 'SpSetting' }, icon: 'zmdi zmdi-settings', label: '设置' }, {
        label: '应用设置',
        icon: 'zmdi zmdi-layers',
        prefix: '/app',
        toggled: false,
        sub_menus: [{ to: { name: 'DashboardSetting' }, label: '服务台轮播图设置' }, { to: { name: 'DashboardShortcut' }, label: '服务台快捷选项设置' }, { to: { name: 'Announcement' }, label: '公告' }, { to: { name: 'ServiceBranch' }, label: '服务网点' }, { to: { name: 'ChargeSpec' }, label: '收费标准' }, { to: { name: 'DevicePresentView' }, label: '机器展示页面' }]
      }, {
        label: '管理功能',
        icon: 'zmdi zmdi-code',
        prefix: '/mgr',
        toggled: false,
        show: function show() {
          return +_this.sp_id === 1;
        },
        sub_menus: [{ to: { name: 'SubDomainAudit' }, label: '子域名审核' }, { to: { name: 'CustomerDomainAudit' }, label: '客户域名审核' }, { to: { name: 'ServiceProviderMgr' }, label: '注册服务商管理' }, { to: { name: 'RevenueExpenditure' }, label: '服务商充值记录' }, { to: { name: 'MiniAppView' }, label: '小程序管理' }, { to: { name: 'FeedbackView' }, label: '用户反馈' }, { to: { name: 'CompileAppView' }, label: 'APP发布' }]
      }]
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['sp_contactor', 'spname', 'sp_id', 'avatar', 'topbarVisible', 'sidebarVisible', 'info_spec', 'info_logo', 'info_use_we_chat_third_party_platform']), (0, _vuex.mapState)({
    route: function route(state) {
      return state.route;
    },
    current_path: function current_path(state) {
      return state.route.path;
    }
  }), {
    avatar_url: {
      get: function get() {
        return this.info_logo || __webpack_require__("AyJ7");
      }
    }
  }),
  watch: {
    current_path: {
      handler: function handler() {
        var _this2 = this;

        this.menus.forEach(function (item, index) {
          if (item.prefix) {
            _this2.$set(_this2.menus, index, _extends({}, item, {
              toggled: _this2.current_path.substr(0, item.prefix.length).toLowerCase() === item.prefix
            }));
          }
        });
      }
    }
  },
  methods: {
    logout_session: function logout_session() {
      (0, _auth.logout)();
    },
    handleToggleSubMenu: function handleToggleSubMenu(menu) {
      menu.toggled = !menu.toggled;
    },
    handleToggleAllMenu: function handleToggleAllMenu() {
      this.menus.forEach(function (menu) {
        return menu.toggled = false;
      });
    },
    resetScroll: function resetScroll() {
      $(this.$refs.scroll_block).slimScroll({
        height: $(window).height() - 80,
        railOpacity: 0.9,
        alwaysVisible: false
      });
    }
  },
  beforeCreated: function beforeCreated() {},
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.resetScroll();

      $(window).resize(function () {
        _this3.resetScroll();
      });
    });
  }
};

/***/ }),

/***/ "TIfe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messageBox = __webpack_require__("oq7i");

var _messageBox2 = _interopRequireDefault(_messageBox);

var _messageBox3 = __webpack_require__("+TD8");

var _messageBox4 = _interopRequireDefault(_messageBox3);

exports.getAuthInfo = getAuthInfo;
exports.logoutAndShowLogin = logoutAndShowLogin;
exports.logout = logout;

__webpack_require__("+BTi");

var _localStorageFallback = __webpack_require__("URp7");

var _localStorageFallback2 = _interopRequireDefault(_localStorageFallback);

var _msg = __webpack_require__("L8QK");

var _helper = __webpack_require__("VSB1");

var _httpclient = __webpack_require__("/rEA");

var _httpclient2 = _interopRequireDefault(_httpclient);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSession() {
  var sessionString = _localStorageFallback2.default.getItem('sp_session');
  if (!sessionString) {
    return null;
  }

  var session = JSON.parse(sessionString);
  if (!session || !session.access_token) {
    return null;
  }

  return session;
}

function extractAccessToken() {
  var session = getSession();
  if (!session) {
    return null;
  }
  return session.access_token;
}

function url_base64_decode(str) {
  var output = str.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += '==';
      break;
    case 3:
      output += '=';
      break;
    default:
      throw 'Illegal base64url string!';
  }
  var result = window.atob(output);
  try {
    return decodeURIComponent(escape(result));
  } catch (err) {
    return result;
  }
}

function delete_cookie(name) {
  document.cookie = name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function getAuthInfo() {
  var accesstoken = extractAccessToken();
  if (!accesstoken) {
    logoutAndShowLogin();
    return null;
  }

  var accessTokenParts = accesstoken.split('.');
  var jwt = JSON.parse(url_base64_decode(accessTokenParts[1]));

  if (jwt.exp < Date.now() / 1000) {
    logoutAndShowLogin();
    return null;
  }

  if (!jwt.tsp) {
    logoutAndShowLogin();
    return null;
  }

  jwt.access_token = accesstoken;
  return jwt;
}

function removeSession() {
  _localStorageFallback2.default.removeItem('sp_session');
  delete_cookie('.AspNetCore.Identity.Application');
  delete_cookie('idsrv.session');
}

function logoutAndShowLogin() {
  removeSession();

  if (false) {
    if (location.hash && location.hash.indexOf('#/dev-login') === 0) {
      return;
    }
    window.location.href = '/#/dev-login?hidetopbar=1&hideleftbar=1';
    return;
  }

  var windowWidth = $(window).width();
  if (windowWidth <= 430) {
    window.location.href = location.hostname.indexOf('yihulu.com') > -1 ? "https://lbx.api.yihulu.com/api/v1" : "https://api.lebaoxiu.com/api/v1" + '/login.html';
    return;
  }

  layer.open({
    type: 2,
    shade: 0.8,
    title: false,
    fixed: false,
    area: ['400px', '500px'],
    content: '/login.html'
  });
}

function logout() {
  _messageBox4.default.confirm('确定要退出系统吗?', '请确认', { center: true }).then(function () {
    removeSession();
    if (_store2.default.state.invite.sub_domain_name && _store2.default.state.invite.sub_domain_name.length) {
      window.location.href = 'https://' + _store2.default.state.invite.sub_domain_name + '.' + (location.hostname.indexOf('yihulu.com') > -1 ? "lbx.yihulu.com" : "lebaoxiu.com");
    } else {
      window.location.href = '/';
    }
  });
}

/***/ }),

/***/ "Uibd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  topbarVisible: function topbarVisible(state) {
    return state.topbarVisible;
  },
  sidebarVisible: function sidebarVisible(state) {
    return state.sidebarVisible;
  },
  token: function token(state) {
    return state.token;
  },
  username: function username(state) {
    return state.user.name;
  },
  spname: function spname(state) {
    return state.user.sp_name;
  },
  sp_id: function sp_id(state) {
    return state.user.sp_id;
  },
  sp_contactor: function sp_contactor(state) {
    return state.user.sp_contactor;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  inviteinfo_is_loading: function inviteinfo_is_loading(state) {
    return state.invite.loading;
  },
  inviteinfo_qrcode: function inviteinfo_qrcode(state) {
    return state.invite.qrcode;
  },
  inviteinfo_reportqrcodes: function inviteinfo_reportqrcodes(state) {
    return state.invite.reportqrcodes;
  },
  inviteinfo_url: function inviteinfo_url(state) {
    return state.invite.url;
  },
  inviteinfo_reporturls: function inviteinfo_reporturls(state) {
    return state.invite.reporturls;
  },
  inviteinfo_home_page_url: function inviteinfo_home_page_url(state) {
    return state.invite.home_page_url;
  },
  inviteinfo_is_apply_sub_domain: function inviteinfo_is_apply_sub_domain(state) {
    return state.invite.is_apply_sub_domain;
  },
  inviteinfo_sub_domain_name: function inviteinfo_sub_domain_name(state) {
    return state.invite.sub_domain_name;
  },
  inviteinfo_sub_domain_status: function inviteinfo_sub_domain_status(state) {
    return state.invite.sub_domain_status;
  },
  inviteinfo_is_apply_own_domain: function inviteinfo_is_apply_own_domain(state) {
    return state.invite.is_apply_own_domain;
  },
  inviteinfo_own_domain_name: function inviteinfo_own_domain_name(state) {
    return state.invite.own_domain_name;
  },
  inviteinfo_own_domain_status: function inviteinfo_own_domain_status(state) {
    return state.invite.own_domain_status;
  },
  info_loading: function info_loading(state) {
    return state.info.loading;
  },
  info_saving: function info_saving(state) {
    return state.info.saving;
  },
  info_name: function info_name(state) {
    return state.info.name;
  },
  info_contactor: function info_contactor(state) {
    return state.info.contactor;
  },
  info_contact_phone: function info_contact_phone(state) {
    return state.info.contact_phone;
  },
  info_email: function info_email(state) {
    return state.info.email;
  },
  info_address: function info_address(state) {
    return state.info.address;
  },
  info_about_content: function info_about_content(state) {
    return state.info.about_content;
  },
  info_logo: function info_logo(state) {
    return state.info.logo;
  },
  info_bind_sys_code: function info_bind_sys_code(state) {
    return state.info.bind_sys_code;
  },
  info_yhl_team_name: function info_yhl_team_name(state) {
    return state.info.yhl_team_name;
  },
  info_yhl_team_id: function info_yhl_team_id(state) {
    return state.info.yhl_team_id;
  },
  info_yhl_branch_id: function info_yhl_branch_id(state) {
    return state.info.yhl_branch_id;
  },
  info_active_edition: function info_active_edition(state) {
    return state.info.active_edition;
  },
  info_expire_date: function info_expire_date(state) {
    return state.info.expire_date;
  },
  info_spec: function info_spec(state) {
    return state.info.spec;
  },
  info_login_account: function info_login_account(state) {
    return state.info.login_account;
  },
  info_left_days: function info_left_days(state) {
    return state.info.left_days;
  },
  info_use_we_chat_third_party_platform: function info_use_we_chat_third_party_platform(state) {
    return state.info.use_we_chat_third_party_platform;
  },
  wechat_loading: function wechat_loading(state) {
    return state.wechat.loading;
  },
  wechat_saving: function wechat_saving(state) {
    return state.wechat.saving;
  },
  wechat_app_id: function wechat_app_id(state) {
    return state.wechat.app_id;
  },
  wechat_app_secret: function wechat_app_secret(state) {
    return state.wechat.app_secret;
  },
  wechat_encoding_aes_key: function wechat_encoding_aes_key(state) {
    return state.wechat.encoding_aes_key;
  },
  wechat_token: function wechat_token(state) {
    return state.wechat.token;
  },
  wechat_server_ip: function wechat_server_ip(state) {
    return state.wechat.server_ip;
  },
  wechat_callback_url: function wechat_callback_url(state) {
    return state.wechat.callback_url;
  },
  wechat_verified_domain: function wechat_verified_domain(state) {
    return state.wechat.verified_domain;
  },
  wechat_qr_code: function wechat_qr_code(state) {
    return state.wechat.qr_code;
  },
  wechat_is_empty: function wechat_is_empty(state) {
    return state.wechat.is_empty;
  },
  wechat_transfer_message_to_kf_system: function wechat_transfer_message_to_kf_system(state) {
    return state.transfer_message_to_kf_system;
  },
  form_loading: function form_loading(state) {
    return state.form.loading;
  },
  form_saving: function form_saving(state) {
    return state.form.saving;
  },
  form_list: function form_list(state) {
    return state.form.list;
  },
  form_total: function form_total(state) {
    return state.form.total;
  },
  shared_form_list: function shared_form_list(state) {
    return state.form.shared_list;
  },
  shared_form_total: function shared_form_total(state) {
    return state.form.shared_total;
  },
  form_df_loading: function form_df_loading(state) {
    return state.form.df_loading;
  },
  form_df: function form_df(state) {
    return state.form.df;
  },
  report_list_loading: function report_list_loading(state) {
    return state.report_list.loading;
  },
  report_list_columns: function report_list_columns(state) {
    return state.report_list.columns;
  },
  report_list_data: function report_list_data(state) {
    return state.report_list.data;
  },
  report_list_additional_parameters: function report_list_additional_parameters(state) {
    return state.report_list.additional_parameters;
  },
  report_list_total: function report_list_total(state) {
    return state.report_list.total;
  },
  report_report_detail_loading: function report_report_detail_loading(state) {
    return state.report_detail.loading;
  },
  report_report_detail_ticket: function report_report_detail_ticket(state) {
    return state.report_detail.ticket;
  },
  report_report_detail_no: function report_report_detail_no(state) {
    return state.report_detail.no;
  },
  report_report_detail_videos: function report_report_detail_videos(state) {
    return state.report_detail.videos;
  },
  report_report_detail_voices: function report_report_detail_voices(state) {
    return state.report_detail.voices;
  },
  report_report_detail_attachments: function report_report_detail_attachments(state) {
    return state.report_detail.attachments;
  },
  report_report_detail_service_ticket: function report_report_detail_service_ticket(state) {
    return state.report_detail.service_ticket;
  },
  report_report_detail_service_ticket_loaded: function report_report_detail_service_ticket_loaded(state) {
    return state.report_detail.service_ticket_loaded;
  },
  wechat_menu_loading: function wechat_menu_loading(state) {
    return state.wechat_menu.loading;
  },
  wechat_menu_saving: function wechat_menu_saving(state) {
    return state.wechat_menu.saving;
  },
  wechat_menu_menu: function wechat_menu_menu(state) {
    return state.wechat_menu.menu;
  },
  sub_domain_list_loading: function sub_domain_list_loading(state) {
    return state.sub_domain_list.loading;
  },
  sub_domain_list_data: function sub_domain_list_data(state) {
    return state.sub_domain_list.data;
  },
  sub_domain_list_total: function sub_domain_list_total(state) {
    return state.sub_domain_list.total;
  },
  account_info_loading: function account_info_loading(state) {
    return state.account_info.loading;
  },
  account_info_spec: function account_info_spec(state) {
    return state.account_info.spec;
  },
  account_info_can_renew_service: function account_info_can_renew_service(state) {
    return state.account_info.can_renew_service;
  },
  account_info_can_upgrade_edition: function account_info_can_upgrade_edition(state) {
    return state.account_info.can_upgrade_edition;
  },
  account_info_active_edition: function account_info_active_edition(state) {
    return state.account_info.active_edition;
  },
  account_info_expire_date: function account_info_expire_date(state) {
    return state.account_info.expire_date;
  },
  account_info_left_days: function account_info_left_days(state) {
    return state.account_info.left_days;
  },
  account_info_list_data: function account_info_list_data(state) {
    return state.account_info.list_data;
  },
  account_info_list_total: function account_info_list_total(state) {
    return state.account_info.list_total;
  },
  account_info_list_loading: function account_info_list_loading(state) {
    return state.account_info.list_loading;
  },
  sp_list_loading: function sp_list_loading(state) {
    return state.sp_list.loading;
  },
  sp_list_data: function sp_list_data(state) {
    return state.sp_list.data;
  },
  sp_list_total: function sp_list_total(state) {
    return state.sp_list.total;
  },
  setting_loading: function setting_loading(state) {
    return state.setting.loading;
  },
  setting_saving: function setting_saving(state) {
    return state.setting.saving;
  },
  setting_setting: function setting_setting(state) {
    return state.setting.setting;
  },
  report_steps_querying: function report_steps_querying(state) {
    return state.report_steps.querying;
  },
  report_steps_steps: function report_steps_steps(state) {
    return state.report_steps.steps;
  },
  report_steps_current: function report_steps_current(state) {
    return state.report_steps.current;
  },
  repair_member_list_loading: function repair_member_list_loading(state) {
    return state.repair_member_list.loading;
  },
  repair_member_list_data: function repair_member_list_data(state) {
    return state.repair_member_list.data;
  },
  repair_member_list_total: function repair_member_list_total(state) {
    return state.repair_member_list.total;
  }
};

/***/ }),

/***/ "UrHU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V2wM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppLoading'),_vm._v(" "),_c('main',{staticClass:"main",class:{'main--fix': !_vm.topbarVisible && _vm.sidebarVisible},attrs:{"data-ma-theme":"blue"}},[(_vm.topbarVisible)?_c('AppHeader'):_vm._e(),_vm._v(" "),(!_vm.topbarVisible)?_c('NavigationTrigger',{attrs:{"sidebar":""}}):_vm._e(),_vm._v(" "),(_vm.sidebarVisible)?_c('AppSidebar'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"content",class:{'content--boxed': !_vm.sidebarVisible}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "VSB1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.date_format = date_format;
exports.isNull = isNull;
exports.isMobile = isMobile;
exports.buttonHelper = buttonHelper;
exports.getQueryString = getQueryString;
exports.uuidv4 = uuidv4;
var object_extends = exports.object_extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

function date_format(date, format) {
  if (typeof date === 'string') {
    var parsedDate = new Date(date);

    if (parsedDate.toString() !== 'Invalid Date') {
      date = parsedDate;
    } else {
      format = date;
      date = new Date();
    }
  }

  if (!format) {
    format = 'yyyy-MM-dd hh:mm';
  }

  var map = {
    "M": date.getMonth() + 1,
    "d": date.getDate(),
    "h": date.getHours(),
    "m": date.getMinutes(),
    "s": date.getSeconds(),
    "q": Math.floor((date.getMonth() + 3) / 3),
    "S": date.getMilliseconds() };
  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    var v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return format;
}

function isNull(s) {
  if (!s) return true;
  s = s.replace(/&nbsp;/ig, "");
  var patrn = /^\s*$/;
  if (!patrn.exec(s)) return false;
  return true;
}

function isMobile(mobile) {
  if (isNull(mobile)) return false;
  var mobileReg = !!mobile.match(/^(0|86|17951)?(13[0-9]|15[012356789]|17[03678]|18[0-9]|14[57])[0-9]{8}$/);
  return mobileReg;
}

function buttonHelper(btn, disabledText) {
  var buttonIsInput = btn.tagName === 'INPUT';
  var originalBtnText = buttonIsInput ? btn.value : btn.innerHTML;

  return {
    disable: function disable() {
      btn.setAttribute('disabled', 'disabled');
      if (buttonIsInput) {
        btn.value = disabledText || '正在执行操作，请耐心等待...';
      } else {
        btn.innerHTML = disabledText || '正在执行操作，请耐心等待...';
      }
    },
    enable: function enable() {
      btn.removeAttribute('disabled');
      if (buttonIsInput) {
        btn.value = originalBtnText;
      } else {
        btn.innerHTML = originalBtnText;
      }
    },
    setText: function setText(text) {
      if (buttonIsInput) {
        btn.value = text;
      } else {
        btn.innerHTML = text;
      }
    },
    isDisabled: function isDisabled() {
      return btn.getAttribute('disabled') !== null;
    }
  };
}

function getQueryString(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
  return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function uuidv4() {
  if ('crypto' in window && window.crypto.getRandomValues) {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  } else {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  }
}

/***/ }),

/***/ "WiM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:{sidebar: true, toggled: _vm.sidebarVisible}},[_c('div',{ref:"scroll_block",staticClass:"scrollbar-inner"},[_c('div',{staticClass:"user"},[_c('div',{staticClass:"user__info",attrs:{"data-toggle":"dropdown"}},[_c('img',{staticClass:"user__img",attrs:{"src":_vm.avatar_url,"alt":""}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"user__name",domProps:{"textContent":_vm._s(_vm.sp_contactor)}}),_vm._v(" "),_c('div',{staticClass:"user__email",domProps:{"textContent":_vm._s(_vm.spname)}})])]),_vm._v(" "),_c('div',{class:{'dropdown-menu': true, show: _vm.showUserDropDownMenu}},[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":{ name: 'SpInfo', params: {}}}},[_vm._v("我的信息")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout_session}},[_vm._v("退出登录")])],1)]),_vm._v(" "),_c('ul',{staticClass:"navigation"},[_vm._l((_vm.menus),function(menu){return [(!menu.sub_menus || !menu.sub_menus.length)?[(!menu.show || menu.show())?_c('router-link',{attrs:{"tag":"li","exact":"","to":menu.to},nativeOn:{"click":function($event){return _vm.handleToggleAllMenu($event)}}},[_c('a',[_c('i',{class:menu.icon}),_vm._v(" "+_vm._s(menu.label))])]):_vm._e()]:_vm._e(),_vm._v(" "),(menu.sub_menus && menu.sub_menus.length && (!menu.show || menu.show()))?[_c('li',{class:{
          navigation__sub: true,
          'navigation__sub--active': _vm.current_path.substr(0,menu.prefix.length).toLowerCase() === menu.prefix,
          'navigation__sub--toggled': menu.toggled
        },on:{"click":function($event){return _vm.handleToggleSubMenu(menu)}}},[_c('a',[_c('i',{class:menu.icon}),_vm._v(" "+_vm._s(menu.label))]),_vm._v(" "),_c('ul',{style:(menu.toggled ? '' : 'display: none'),on:{"click":function($event){return _vm.handleToggleSubMenu(menu)}}},_vm._l((menu.sub_menus),function(submenu){return (!submenu.show || submenu.show())?_c('router-link',{key:submenu.label,attrs:{"tag":"li","to":submenu.to}},[_c('a',{domProps:{"textContent":_vm._s(submenu.label)}})]):_vm._e()}),1)])]:_vm._e()]})],2)])])}
var staticRenderFns = []


/***/ }),

/***/ "Y9iB":
/***/ (function(module, exports) {

module.exports = autosize;

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("lRwf");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("pRNm");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dashboard = function Dashboard(r) {
  return __webpack_require__.e/* require.ensure */(14).then((function () {
    return r(__webpack_require__("tUnb"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SpInfo = function SpInfo(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__("cjf8"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AccountInfo = function AccountInfo(r) {
  return __webpack_require__.e/* require.ensure */(18).then((function () {
    return r(__webpack_require__("0nwY"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Tickets = function Tickets(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__("HLac"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RepairForm = function RepairForm(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__("z85/"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RepairTemplate = function RepairTemplate(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__("B9ri"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CreateRepairForm = function CreateRepairForm(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__("V8Wq"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CreateRepairTemplate = function CreateRepairTemplate(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__("IdsS"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SpSetting = function SpSetting(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__("YOQD"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DashboardSetting = function DashboardSetting(r) {
  return __webpack_require__.e/* require.ensure */(16).then((function () {
    return r(__webpack_require__("R5cI"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DashboardShortcut = function DashboardShortcut(r) {
  return __webpack_require__.e/* require.ensure */(15).then((function () {
    return r(__webpack_require__("p58Q"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Announcement = function Announcement(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__("lnh0"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AnnouncementModify = function AnnouncementModify(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__("K4Vi"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ServiceBranch = function ServiceBranch(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__("w1j9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ChargeSpec = function ChargeSpec(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__("gGmk"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RepairMember = function RepairMember(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__("PSCq"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ReportView = function ReportView(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__("OOcv"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ReportServiceTicketView = function ReportServiceTicketView(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__("elu3"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var WeChat = function WeChat(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("QJo9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var WeChatMenu = function WeChatMenu(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("DVaS"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var WeChatAuthorizerMenu = function WeChatAuthorizerMenu(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("Wb03"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var WeChatMenuOld = function WeChatMenuOld(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("CT76"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var WeChatSubscribeReply = function WeChatSubscribeReply(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("dS1u"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Binding = function Binding(r) {
  return __webpack_require__.e/* require.ensure */(17).then((function () {
    return r(__webpack_require__("UyEu"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var SubDomainAudit = function SubDomainAudit(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("HOCi"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ServiceProviderMgr = function ServiceProviderMgr(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("QmbE"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CustomerDomainAudit = function CustomerDomainAudit(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("35w8"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RevenueExpenditure = function RevenueExpenditure(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("3a96"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MiniAppView = function MiniAppView(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("JrFV"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CompileAppView = function CompileAppView(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("RiIB"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var FeedbackView = function FeedbackView(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("fijy"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var DevicePresentView = function DevicePresentView(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__("XJ9e"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DevicePresentModify = function DevicePresentModify(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__("jSap"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var DevLogin = function DevLogin(r) {
  return __webpack_require__.e/* require.ensure */(19).then((function () {
    return r(__webpack_require__("u7pe"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  linkActiveClass: 'navigation__active',
  routes: [{
    path: '/dev-login',
    name: 'DevLogin',
    component: DevLogin
  }, {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  }, {
    path: '/tickets',
    name: 'Tickets',
    component: Tickets
  }, {
    path: '/tickets/m/:rm_id',
    name: 'RepairMemberTickets',
    component: Tickets
  }, {
    path: '/wechat/info',
    name: 'WeChat',
    component: WeChat
  }, {
    path: '/wechat/menu',
    name: 'WeChatMenuOld',
    component: WeChatMenuOld
  }, {
    path: '/wechat/subscribe_reply',
    name: 'WeChatSubscribeReply',
    component: WeChatSubscribeReply
  }, {
    path: '/authorizer/list',
    name: 'WeChatAuthorizerMenu',
    component: WeChatAuthorizerMenu
  }, {
    path: '/authorizer/menu',
    name: 'WeChatMenu',
    component: WeChatMenu
  }, {
    path: '/account',
    name: 'AccountInfo',
    component: AccountInfo
  }, {
    path: '/info',
    name: 'SpInfo',
    component: SpInfo
  }, {
    path: '/member',
    name: 'RepairMember',
    component: RepairMember
  }, {
    path: '/setting',
    name: 'SpSetting',
    component: SpSetting
  }, {
    path: '/app/dashboard',
    name: 'DashboardSetting',
    component: DashboardSetting
  }, {
    path: '/app/shortcut',
    name: 'DashboardShortcut',
    component: DashboardShortcut
  }, {
    path: '/app/announcement',
    name: 'Announcement',
    component: Announcement
  }, {
    path: '/app/announcement-create',
    name: 'CreateAnnouncement',
    component: AnnouncementModify
  }, {
    path: '/app/announcement-edit/:id',
    name: 'EditAnnouncement',
    component: AnnouncementModify
  }, {
    path: '/app/article/servicebranch',
    name: 'ServiceBranch',
    component: ServiceBranch
  }, {
    path: '/app/article/chargespec',
    name: 'ChargeSpec',
    component: ChargeSpec
  }, {
    path: '/form',
    name: 'RepairForm',
    component: RepairForm
  }, {
    path: '/template',
    name: 'RepairTemplate',
    component: RepairTemplate
  }, {
    path: '/form/create',
    name: 'CreateRepairForm',
    component: CreateRepairForm
  }, {
    path: '/form/edit/:id',
    name: 'EditRepairForm',
    component: CreateRepairForm
  }, {
    path: '/template/create',
    name: 'CreateRepairTemplate',
    component: CreateRepairTemplate
  }, {
    path: '/template/edit/:id',
    name: 'EditRepairTemplate',
    component: CreateRepairTemplate
  }, {
    path: '/tickets/:id',
    name: 'ViewRepairForm',
    component: ReportView
  }, {
    path: '/tickets/:id/service',
    name: 'ViewServiceTicket',
    component: ReportServiceTicketView
  }, {
    path: '/binding',
    name: 'Binding',
    component: Binding
  }, {
    path: '/mgr/subdomain',
    name: 'SubDomainAudit',
    component: SubDomainAudit
  }, {
    path: '/mgr/sp',
    name: 'ServiceProviderMgr',
    component: ServiceProviderMgr
  }, {
    path: '/mgr/cusdomain',
    name: 'CustomerDomainAudit',
    component: CustomerDomainAudit
  }, {
    path: '/mgr/rex',
    name: 'RevenueExpenditure',
    component: RevenueExpenditure
  }, {
    path: '/mgr/miniapp',
    name: 'MiniAppView',
    component: MiniAppView
  }, {
    path: '/mgr/compileapp',
    name: 'CompileAppView',
    component: CompileAppView
  }, {
    path: '/mgr/feedback',
    name: 'FeedbackView',
    component: FeedbackView
  }, {
    path: '/app/device-tmpl',
    name: 'DevicePresentView',
    component: DevicePresentView
  }, {
    path: '/app/device-tmpl/:id',
    name: 'DevicePresentModify',
    component: DevicePresentModify
  }]
});

router.afterEach(function (to, from) {
  try {
    if (window.parent && window.parent.postMessage) {
      window.parent.postMessage(JSON.stringify({ msg: 'EVENT_LBX_ROUTE_CHANGE', name: to.name, path: to.path }), '*');
    }
  } catch (e) {}
});

exports.default = router;

/***/ }),

/***/ "Yd1y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yupf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__ = __webpack_require__("v1bw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2725cb20_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__ = __webpack_require__("zU0K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xubR")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2725cb20_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2725cb20_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cwe7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fEJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fjsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__ = __webpack_require__("SMMp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0984963a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__ = __webpack_require__("WiM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("n1PR")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_sidebar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0984963a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0984963a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "hOf8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vuex = __webpack_require__("SJI6");

exports.default = {
  components: {},
  props: {
    sidebar: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  computed: _extends({}, (0, _vuex.mapState)(['sidebarVisible'])),
  methods: _extends({}, (0, _vuex.mapActions)(['toggleSidebar'])),
  beforeCreated: function beforeCreated() {},
  created: function created() {},
  mounted: function mounted() {}
};

/***/ }),

/***/ "i3Wq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{'navigation-trigger': true, 'd-xl-none': true, toggled: _vm.sidebarVisible,'navigation-trigger-sidebar': _vm.sidebar,
    'navigation-trigger-sidebar-toggled': _vm.sidebar && !_vm.sidebarVisible},on:{"click":function($event){return _vm.toggleSidebar()}}},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-trigger__inner"},[_c('i',{staticClass:"navigation-trigger__line"}),_vm._v(" "),_c('i',{staticClass:"navigation-trigger__line"}),_vm._v(" "),_c('i',{staticClass:"navigation-trigger__line"})])}]


/***/ }),

/***/ "lRwf":
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "ldce":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorEmitter = function () {
  function ErrorEmitter() {
    _classCallCheck(this, ErrorEmitter);
  }

  _createClass(ErrorEmitter, [{
    key: 'install',
    value: function install() {
      try {
        if (true) {
          console.log('%c请不要在控制台操作，以免丢失数据', 'font-size:100px;color:#fff;text-shadow:0 1px 0#ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);');
        }
      } catch (e) {}

      window.addEventListener('error', function (msg, url, row, col, error) {
        var newMsg = msg;

        if (error && error.stack) {
          newMsg = ErrorEmitter.processStackMsg(error);
        }

        if (ErrorEmitter.isOBJByType(newMsg, "Event")) {
          newMsg += newMsg.type ? "--" + newMsg.type + "--" + (newMsg.target ? newMsg.target.tagName + "::" + newMsg.target.src : "") : "";
        }

        newMsg = (newMsg + "" || "").substr(0, 500);

        if (newMsg.toLowerCase().indexOf('script error') > -1) {
          console.error('Script Error: See Browser Console for Detail');
        } else {
          console.error(newMsg);
        }

        return true;
      }, true);

      window.addEventListener("unhandledrejection", function (e) {
        e.preventDefault();
        console.log(e.reason);
        return true;
      });
    }
  }, {
    key: 'report',
    value: function report(_ref) {
      var source = _ref.source,
          args = _objectWithoutProperties(_ref, ['source']);

      console.log({
        source: source,
        args: args
      });
    }
  }], [{
    key: 'isOBJByType',
    value: function isOBJByType(o, type) {
      return Object.prototype.toString.call(o) === "[object " + (type || "Object") + "]";
    }
  }, {
    key: 'processStackMsg',
    value: function processStackMsg(error) {
      var stack = error.stack.replace(/\n/gi, "").split(/\bat\b/).slice(0, 9).join("@").replace(/\?[^:]+/gi, "");
      var msg = error.toString();
      if (stack.indexOf(msg) < 0) {
        stack = msg + "@" + stack;
      }
      return stack;
    }
  }]);

  return ErrorEmitter;
}();

var error_emitter = new ErrorEmitter();
exports.default = error_emitter;

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _msg = __webpack_require__("L8QK");

var _qs = __webpack_require__("mw3O");

var _qs2 = _interopRequireDefault(_qs);

var _mutationTypes = __webpack_require__("Du/2");

var _httpclient = __webpack_require__("/rEA");

var _httpclient2 = _interopRequireDefault(_httpclient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  toggleSidebar: function toggleSidebar(_ref) {
    var commit = _ref.commit;

    commit(_mutationTypes.TOGGLE_SIDEBAR);
  },
  fetchInviteInfo: function fetchInviteInfo(_ref2) {
    var commit = _ref2.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_INVITE_INFO);

      _httpclient2.default.get("/ServiceProvider/inviteinfo").then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_INVITE_INFO, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchSpInfo: function fetchSpInfo(_ref3, spId) {
    var commit = _ref3.commit,
        state = _ref3.state;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SP_INFO);

      var effectiveSpId = spId === undefined || spId === null ? state.user && state.user.sp_id : spId;
      if (!effectiveSpId) {
        (0, _msg.showError)("服务商ID未初始化，请刷新页面或重新登录");
        reject(new Error("ServiceProvider id is required"));
        return;
      }
      _httpclient2.default.get("/ServiceProvider/" + effectiveSpId).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SP_INFO, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  saveSpInfo: function saveSpInfo(_ref4, spInfo) {
    var commit = _ref4.commit;

    commit(_mutationTypes.REQUEST_SAVE_SP_INFO);

    _httpclient2.default.post("/ServiceProvider", spInfo).then(function (resp) {
      if (resp.biz_code === 0) {
        commit(_mutationTypes.RECEIVE_SAVE_SP_INFO, spInfo);
        (0, _msg.showSuccess)("保存成功");
      } else {
        (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
      }
    });
  },
  updateInfoName: function updateInfoName(_ref5, payload) {
    var commit = _ref5.commit;

    commit(_mutationTypes.UPDATE_INFO_NAME, payload);
  },
  updateInfoContactor: function updateInfoContactor(_ref6, payload) {
    var commit = _ref6.commit;

    commit(_mutationTypes.UPDATE_INFO_CONTACTOR, payload);
  },
  updateWeChatAppId: function updateWeChatAppId(_ref7, payload) {
    var commit = _ref7.commit;

    commit(_mutationTypes.UPDATE_WECHAT_APP_ID, payload);
  },
  updateWeChatAppSecret: function updateWeChatAppSecret(_ref8, payload) {
    var commit = _ref8.commit;

    commit(_mutationTypes.UPDATE_WECHAT_APP_SECRET, payload);
  },
  updateWeChatEncodingAesKey: function updateWeChatEncodingAesKey(_ref9, payload) {
    var commit = _ref9.commit;

    commit(_mutationTypes.UPDATE_WECHAT_ENCODING_AES_KEY, payload);
  },
  fetchWeChatInfo: function fetchWeChatInfo(_ref10) {
    var commit = _ref10.commit;

    commit(_mutationTypes.REQUEST_WECHAT_INFO);

    _httpclient2.default.get("/wechataccount").then(function (resp) {
      if (resp.biz_code === 0) {
        commit(_mutationTypes.RECEIVE_WECHAT_INFO, resp.data);
      } else {
        (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
      }
    });
  },
  saveWeChatInfo: function saveWeChatInfo(_ref11, payload) {
    var commit = _ref11.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SAVE_WECHAT_INFO);

      _httpclient2.default.post("/wechataccount", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SAVE_WECHAT_INFO, resp.data);
          (0, _msg.showSuccess)("保存成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  requestClearWeChatSetting: function requestClearWeChatSetting(_ref12) {
    var commit = _ref12.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_WECHAT_CLEAR_SETTING);

      _httpclient2.default.post("/wechataccount/clear").then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_WECHAT_CLEAR_SETTING);
          (0, _msg.showSuccess)("以清除微信配置信息");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  saveFormInfo: function saveFormInfo(_ref13, payload) {
    var commit = _ref13.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SAVE_FORM_INFO);

      _httpclient2.default.post("/repairform", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SAVE_FORM_INFO, resp.data);
          (0, _msg.showSuccess)("保存成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  useShareForm: function useShareForm(_ref14, payload) {
    var commit = _ref14.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SAVE_FORM_INFO);

      _httpclient2.default.post("/repairform/share/" + payload.share_form_id + "/use", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SAVE_FORM_INFO, resp.data);
          (0, _msg.showSuccess)("保存成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  requestFormList: function requestFormList(_ref15, payload) {
    var commit = _ref15.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_FORM_LIST);

      _httpclient2.default.get("/repairform", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_FORM_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  requestSharedFormList: function requestSharedFormList(_ref16, payload) {
    var commit = _ref16.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SHARED_FORM_LIST);

      _httpclient2.default.get("/repairform/share", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SHARED_FORM_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setDefaultForm: function setDefaultForm(_ref17, formId) {
    var commit = _ref17.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairform/" + formId + "/use").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("已设置为默认表单");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setFormSharable: function setFormSharable(_ref18, payload) {
    var commit = _ref18.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairform/share/" + payload.formId + "/stat/" + payload.share).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)(payload.share ? "表单已设置为共享" : "表单已取消共享");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setFormVisible: function setFormVisible(_ref19, payload) {
    var commit = _ref19.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairform/visible/" + payload.formId + "/stat/" + payload.visible).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)(payload.visible ? "表单已设置为在移动端显示" : "表单已在移动端隐藏");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  deleteForm: function deleteForm(_ref20, formId) {
    var commit = _ref20.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairform/" + formId + "/delete").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("删除成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  previewForm: function previewForm(_ref21, formId) {
    var commit = _ref21.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/repairform/" + formId + "/preview").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchFormInfo: function fetchFormInfo(_ref22, formId) {
    var commit = _ref22.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_FORM_INFO);

      _httpclient2.default.get("/repairform/" + formId).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_FORM_INFO, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchDefaultFormInfo: function fetchDefaultFormInfo(_ref23) {
    var commit = _ref23.commit;

    commit(_mutationTypes.REQUEST_DEFAULT_FORM_INFO);

    _httpclient2.default.get("/repairform/active").then(function (resp) {
      if (resp.biz_code === 0) {
        commit(_mutationTypes.RECEIVE_DEFAULT_FORM_INFO, resp.data);
      } else {
        (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
      }
    });
  },
  fetchReportList: function fetchReportList(_ref24, payload) {
    var commit = _ref24.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_MY_TICKET_LIST);

      _httpclient2.default.get("/repairticket/sp/ele", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_MY_TICKET_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchTicketInfo: function fetchTicketInfo(_ref25, id) {
    var commit = _ref25.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_TICKET_DETAIL);

      _httpclient2.default.get("/repairticket/sp/" + id).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_TICKET_DETAIL, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchYhlServiceTicketInfo: function fetchYhlServiceTicketInfo(_ref26, payload) {
    var commit = _ref26.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SERVICE_TICKET_DETAIL);

      _httpclient2.default.get("/YhlCompat/fetch/" + payload.spId + "/i/" + payload.id + "/serviceticket").then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SERVICE_TICKET_DETAIL, resp.data);
          resolve(resp);
        } else {
          commit(_mutationTypes.RECEIVE_SERVICE_TICKET_DETAIL, null);
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateTicketProgress: function updateTicketProgress(_ref27, payload) {
    var commit = _ref27.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairticket/progress", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("进度保存成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updatePassword: function updatePassword(_ref28, payload) {
    var commit = _ref28.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_CHANGE_PASSWORD);

      _httpclient2.default.post("/ServiceProvider/updatepwd", payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_CHANGE_PASSWORD);
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("密码修改成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  createWeChatMenu: function createWeChatMenu(_ref29, payload) {
    var commit = _ref29.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_CREATE_WECHAT_MENU);

      _httpclient2.default.post("/wechatmenu", payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_CREATE_WECHAT_MENU);
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("微信菜单创建成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchWeChatMenu: function fetchWeChatMenu(_ref30) {
    var commit = _ref30.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_FETCH_WECHAT_MENU);

      _httpclient2.default.get("/wechatmenu").then(function (resp) {
        commit(_mutationTypes.RECEIVE_FETCH_WECHAT_MENU, resp.data);
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  bindYhlTeam: function bindYhlTeam(_ref31, payload) {
    var commit = _ref31.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_BIND_YHL_TEAM);

      _httpclient2.default.post("/YhlCompat/yhlteam/bind", payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_BIND_YHL_TEAM);
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("一葫芦企业绑定成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  applySubDomain: function applySubDomain(_ref32, payload) {
    var commit = _ref32.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_APPLY_SUB_DOMAIN);

      _httpclient2.default.post("/subdomain/apply", payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_APPLY_SUB_DOMAIN);
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("二级域名申请成功, 请等待审核通过");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  applyOwnDomain: function applyOwnDomain(_ref33, payload) {
    var commit = _ref33.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_APPLY_SUB_DOMAIN);

      _httpclient2.default.post("/owndomain/apply", payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_APPLY_SUB_DOMAIN);
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("二级域名申请成功, 请等待审核通过");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchSubDomainList: function fetchSubDomainList(_ref34, payload) {
    var commit = _ref34.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SUBDOMAIN_LIST);

      _httpclient2.default.get("/subdomain", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SUBDOMAIN_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  auditSubDomain: function auditSubDomain(_ref35, payload) {
    var commit = _ref35.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("subdomain/" + payload.id + "/pass", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("二级域名申请已通过");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  rejectSubDomain: function rejectSubDomain(_ref36, payload) {
    var commit = _ref36.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("subdomain/" + payload.id + "/reject", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("二级域名申请已驳回");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchOwnDomainList: function fetchOwnDomainList(_ref37, payload) {
    var commit = _ref37.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SUBDOMAIN_LIST);

      _httpclient2.default.get("/owndomain", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SUBDOMAIN_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  auditOwnDomain: function auditOwnDomain(_ref38, payload) {
    var commit = _ref38.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("owndomain/" + payload.id + "/pass", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("域名申请已通过");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  rejectOwnDomain: function rejectOwnDomain(_ref39, payload) {
    var commit = _ref39.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("owndomain/" + payload.id + "/reject", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("域名申请已驳回");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchAccountInfo: function fetchAccountInfo(_ref40) {
    var commit = _ref40.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_ACCOUNT_INFO);

      _httpclient2.default.get("/ServiceProvider/account").then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_ACCOUNT_INFO, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  renew: function renew(_ref41, payload) {
    var commit = _ref41.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_ACCOUNT_RENEW);

      _httpclient2.default.post("/ServiceProvider/account/renew", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_ACCOUNT_RENEW, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchOrderInfo: function fetchOrderInfo(_ref42, payload) {
    var commit = _ref42.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/ServiceProvider/account/" + payload + "/state").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  upgrade: function upgrade(_ref43, payload) {
    var commit = _ref43.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_ACCOUNT_RENEW);

      _httpclient2.default.post("/ServiceProvider/account/upgrade", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_ACCOUNT_RENEW, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchAccountSzList: function fetchAccountSzList(_ref44, payload) {
    var commit = _ref44.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_ACCOUNT_SZ_LIST);

      _httpclient2.default.get("/serviceprovider/account/list", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_ACCOUNT_SZ_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchAllAccountList: function fetchAllAccountList(_ref45, payload) {
    var commit = _ref45.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_ACCOUNT_SZ_LIST);

      _httpclient2.default.get("/serviceprovider/account/list/all", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_ACCOUNT_SZ_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  forceAccountRecordComplete: function forceAccountRecordComplete(_ref46, payload) {
    var commit = _ref46.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_ACCOUNT_SZ_LIST);

      _httpclient2.default.post("/serviceprovider/account/" + payload.id + "/complete", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchSpList: function fetchSpList(_ref47, payload) {
    var commit = _ref47.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SP_LIST);

      _httpclient2.default.get("/serviceprovider", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SP_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setSpBalance: function setSpBalance(_ref48, payload) {
    var commit = _ref48.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/serviceprovider/" + payload.id + "/balance", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
          (0, _msg.showSuccess)("保存成功");
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setSpSpec: function setSpSpec(_ref49, payload) {
    var commit = _ref49.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/serviceprovider/" + payload.id + "/spec", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
          (0, _msg.showSuccess)("保存成功");
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  unBindYhlTeam: function unBindYhlTeam(_ref50, payload) {
    var commit = _ref50.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_BIND_YHL_TEAM);

      _httpclient2.default.post("/YhlCompat/yhlteam/unbind/" + payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_BIND_YHL_TEAM);
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("一葫芦企业解绑成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchSpSetting: function fetchSpSetting(_ref51) {
    var commit = _ref51.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_SP_SETTING);

      _httpclient2.default.get("/ServiceProvider/setting").then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_SP_SETTING, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  saveSpSetting: function saveSpSetting(_ref52, spInfo) {
    var commit = _ref52.commit;

    commit(_mutationTypes.REQUEST_SAVE_SP_SETTING);

    _httpclient2.default.post("/ServiceProvider/setting", spInfo).then(function (resp) {
      if (resp.biz_code === 0) {
        commit(_mutationTypes.RECEIVE_SAVE_SP_SETTING, spInfo);
        (0, _msg.showSuccess)("保存成功");
      } else {
        (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
      }
    });
  },
  fetchAuthorizerList: function fetchAuthorizerList(_ref53, payload) {
    var commit = _ref53.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_FETCH_AUTHORIZER_LIST);

      _httpclient2.default.get("/wechatthirdparty/query/" + payload.type).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_FETCH_AUTHORIZER_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  unbindAuthorizer: function unbindAuthorizer(_ref54, payload) {
    var commit = _ref54.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/wechatthirdparty/authorizer/" + payload + "/unbind").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchWeChatThirdPartyMenu: function fetchWeChatThirdPartyMenu(_ref55, payload) {
    var commit = _ref55.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_FETCH_WECHAT_MENU);

      _httpclient2.default.get("/wechatthirdpartymenu/" + payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_FETCH_WECHAT_MENU, resp.data);
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  createWeChatThirdPartyMenu: function createWeChatThirdPartyMenu(_ref56, payload) {
    var commit = _ref56.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_CREATE_WECHAT_MENU);

      _httpclient2.default.post("/wechatthirdpartymenu/" + payload.authorizer_id, payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_CREATE_WECHAT_MENU);
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("微信授权订阅号菜单创建成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  getWeChatThirdPartyMenuUrl: function getWeChatThirdPartyMenuUrl(_ref57, payload) {
    var commit = _ref57.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_CREATE_WECHAT_MENU);

      _httpclient2.default.post("/wechatthirdpartymenu/" + payload.authorizer_id + "/single_menu_url", payload).then(function (resp) {
        commit(_mutationTypes.RECEIVE_CREATE_WECHAT_MENU);
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchTicketSteps: function fetchTicketSteps(_ref58, payload) {
    var commit = _ref58.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_FETCH_TICKET_STEPS);

      _httpclient2.default.get("/repairticket/sp/" + payload.ticketId + "/steps").then(function (resp) {
        commit(_mutationTypes.RECEIVE_FETCH_TICKET_STEPS, resp.data);
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchRatePointRemarks: function fetchRatePointRemarks(_ref59) {
    var commit = _ref59.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/rate/point/remark").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateRatePointRemarks: function updateRatePointRemarks(_ref60, payload) {
    var commit = _ref60.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/rate/point/remark", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("保存成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchRateTags: function fetchRateTags(_ref61) {
    var commit = _ref61.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/rate/tags").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchAutoRateSetting: function fetchAutoRateSetting(_ref62) {
    var commit = _ref62.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/rate/point/auto/setting").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  saveAutoRateSetting: function saveAutoRateSetting(_ref63, payload) {
    var commit = _ref63.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/rate/point/auto/setting", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("自动评价设置保存成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  createRateTag: function createRateTag(_ref64, payload) {
    var commit = _ref64.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/rate/tags", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("评价标签保存成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  removeRateTag: function removeRateTag(_ref65, payload) {
    var commit = _ref65.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/rate/tags/" + payload.tagId + "/remove").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("评价标签已删除");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  getTicketRateInfo: function getTicketRateInfo(_ref66, payload) {
    var commit = _ref66.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/rate/point/" + payload.ticketId).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  checkTicketCanRate: function checkTicketCanRate(_ref67, payload) {
    var commit = _ref67.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/rate/point/check/" + payload.ticketId).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniApps: function fetchMiniApps(_ref68) {
    var commit = _ref68.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/query").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniAppTesters: function fetchMiniAppTesters(_ref69, payload) {
    var commit = _ref69.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/tester/" + payload).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  bindMiniAppTester: function bindMiniAppTester(_ref70, payload) {
    var commit = _ref70.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/tester/" + payload.authorizerId + "/" + payload.wechatId + "/bind").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("绑定成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  unbindMiniAppTester: function unbindMiniAppTester(_ref71, payload) {
    var commit = _ref71.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/tester/" + payload.authorizerId + "/" + payload.wechatId + "/unbind").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("解除绑定成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniAppTemplateLists: function fetchMiniAppTemplateLists(_ref72) {
    var commit = _ref72.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/template_list").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  commitMiniApp: function commitMiniApp(_ref73, payload) {
    var commit = _ref73.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload.authorizer_id + "/commit", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("小程序代码上传成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  getMiniAppTestQrCode: function getMiniAppTestQrCode(_ref74, payload) {
    var commit = _ref74.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/" + payload + "/qrcode/test").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setMiniAppSupportVersion: function setMiniAppSupportVersion(_ref75, payload) {
    var commit = _ref75.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload.authorizerId + "/support_version/" + payload.version, payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("设置最低基础库成功");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniAppPageLists: function fetchMiniAppPageLists(_ref76, payload) {
    var commit = _ref76.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/" + payload + "/page_list").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniAppCategoryLists: function fetchMiniAppCategoryLists(_ref77, payload) {
    var commit = _ref77.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/" + payload + "/category_list").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  submitAuditMiniApp: function submitAuditMiniApp(_ref78, payload) {
    var commit = _ref78.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload.authorizer_id + "/submit_audit", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u5C0F\u7A0B\u5E8F\u5DF2\u63D0\u4EA4\u5BA1\u6838");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniAppAuditStatus: function fetchMiniAppAuditStatus(_ref79, payload) {
    var commit = _ref79.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/" + payload + "/audit_status").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  releaseMiniApp: function releaseMiniApp(_ref80, payload) {
    var commit = _ref80.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload + "/release", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u5C0F\u7A0B\u5E8F\u5DF2\u53D1\u5E03");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setMiniAppSearchable: function setMiniAppSearchable(_ref81, payload) {
    var commit = _ref81.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload.authorizer_id + "/search_status/" + payload.searchable).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u5C0F\u7A0B\u5E8F\u53EF\u641C\u7D22\u72B6\u6001\u5DF2\u8BBE\u7F6E");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniAppSearchable: function fetchMiniAppSearchable(_ref82, payload) {
    var commit = _ref82.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/" + payload + "/search_status").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setMiniAppVisitable: function setMiniAppVisitable(_ref83, payload) {
    var commit = _ref83.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload.authorizer_id + "/search_status/" + payload.visible).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u5C0F\u7A0B\u5E8F\u53EF\u89C1\u72B6\u6001\u5DF2\u8BBE\u7F6E");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  revertMiniApp: function revertMiniApp(_ref84, payload) {
    var commit = _ref84.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload + "/revert", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u5C0F\u7A0B\u5E8F\u53D1\u5E03\u7248\u672C\u5DF2\u56DE\u9000");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  revokeAuditMiniApp: function revokeAuditMiniApp(_ref85, payload) {
    var commit = _ref85.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload + "/revoke_audit", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u5C0F\u7A0B\u5E8F\u5DF2\u64A4\u56DE\u5BA1\u6838");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  getTicketGeoInfo: function getTicketGeoInfo(_ref86, payload) {
    var commit = _ref86.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/RepairTicket/sp/" + payload.ticketId + "/geo").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateAuthorizerInfo: function updateAuthorizerInfo(_ref87, payload) {
    var commit = _ref87.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/authorizer/" + payload.id, payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u516C\u4F17\u53F7\u4FE1\u606F\u5DF2\u4FDD\u5B58");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchRmList: function fetchRmList(_ref88, payload) {
    var commit = _ref88.commit;

    return new Promise(function (resolve, reject) {
      commit(_mutationTypes.REQUEST_RM_LIST);

      _httpclient2.default.get("/repairmember", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          commit(_mutationTypes.RECEIVE_RM_LIST, resp.data);
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchWeChatThirdPartyComponentLoginUrl: function fetchWeChatThirdPartyComponentLoginUrl(_ref89) {
    var commit = _ref89.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/componentloginurl").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setRmVerified: function setRmVerified(_ref90, payload) {
    var commit = _ref90.commit;
    var id = payload.id;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairmember/" + id + "/verify").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u5DF2\u5BA1\u6838\u62A5\u4FEE\u4F1A\u5458");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setRmUnVerified: function setRmUnVerified(_ref91, payload) {
    var commit = _ref91.commit;
    var id = payload.id;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairmember/" + id + "/unverify").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u62A5\u4FEE\u4F1A\u5458\u5DF2\u8BBE\u7F6E\u672A\u5BA1\u6838");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  deleteRm: function deleteRm(_ref92, payload) {
    var commit = _ref92.commit;
    var id = payload.id;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairmember/" + id + "/delete").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u62A5\u4FEE\u4F1A\u5458\u5DF2\u5220\u9664");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  reSyncTicket: function reSyncTicket(_ref93, ticketId) {
    var commit = _ref93.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairticket/sp/" + ticketId + "/resync").then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u62A5\u4FEE\u5355\u5DF2\u91CD\u65B0\u540C\u6B65");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchWeChatReplySetting: function fetchWeChatReplySetting(_ref94) {
    var commit = _ref94.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatAccount/subscribe_reply").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchWeChatThirdPartyReplySetting: function fetchWeChatThirdPartyReplySetting(_ref95, id) {
    var commit = _ref95.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/" + id + "/subscribe_reply").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateWeChatReplySetting: function updateWeChatReplySetting(_ref96, payload) {
    var commit = _ref96.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatAccount/subscribe_reply", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u516C\u4F17\u53F7\u5173\u6CE8\u56DE\u590D\u4FE1\u606F\u5DF2\u4FDD\u5B58");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateWeChatThirdPartyReplySetting: function updateWeChatThirdPartyReplySetting(_ref97, payload) {
    var commit = _ref97.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/" + payload.id + "/subscribe_reply", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          (0, _msg.showSuccess)("\u516C\u4F17\u53F7\u5173\u6CE8\u56DE\u590D\u4FE1\u606F\u5DF2\u4FDD\u5B58");
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchDevFormSetting: function fetchDevFormSetting(_ref98, id) {
    var commit = _ref98.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/YhlDeviceAsset/sp/" + id + "/form_setting").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateDevFormSetting: function updateDevFormSetting(_ref99, payload) {
    var commit = _ref99.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/YhlDeviceAsset/form_setting", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
          (0, _msg.showSuccess)("保存成功");
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  deleteTicket: function deleteTicket(_ref100, payload) {
    var commit = _ref100.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairticket/sp/" + payload.id + "/delete").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
          (0, _msg.showSuccess)("以删除报修单");
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  batchDeleteTickets: function batchDeleteTickets(_ref101, payload) {
    var commit = _ref101.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/repairticket/sp/batchdelete", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
          (0, _msg.showSuccess)("已删除报修单");
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  compileApp: function compileApp(_ref102, payload) {
    var commit = _ref102.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/app/compile", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
          (0, _msg.showSuccess)("已提交发布请求");
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchAppCompiles: function fetchAppCompiles(_ref103, payload) {
    var commit = _ref103.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/app", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchLatestApp: function fetchLatestApp(_ref104, spId) {
    var commit = _ref104.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/app/" + spId + "/latest").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchFeedbacks: function fetchFeedbacks(_ref105, payload) {
    var commit = _ref105.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/feedback/", {
        params: payload,
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchFeedbackDetail: function fetchFeedbackDetail(_ref106, id) {
    var commit = _ref106.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/feedback/" + id).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  processFeedback: function processFeedback(_ref107, payload) {
    var commit = _ref107.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/feedback/" + payload.id + "/process", payload).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  getMiniAppPrivacySetting: function getMiniAppPrivacySetting(_ref108, payload) {
    var commit = _ref108.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.get("/WeChatThirdParty/miniapp/mgr/" + payload.authorizer_id + "/privacy", {
        params: { privacy_ver: payload.privacy_ver },
        paramsSerializer: function paramsSerializer(params) {
          return _qs2.default.stringify(params, { arrayFormat: "repeat" });
        }
      }).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setMiniAppPrivacySetting: function setMiniAppPrivacySetting(_ref109, payload) {
    var commit = _ref109.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload.authorizer_id + "/privacy", payload.setting).then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateAuthorizerDomain: function updateAuthorizerDomain(_ref110, payload) {
    var commit = _ref110.commit;

    return new Promise(function (resolve, reject) {
      _httpclient2.default.post("/WeChatThirdParty/miniapp/mgr/" + payload.authorizer_id + "/update_domain").then(function (resp) {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          (0, _msg.showError)(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  }
};

/***/ }),

/***/ "n1PR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oq7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pRNm":
/***/ (function(module, exports) {

module.exports = VueRouter;

/***/ }),

/***/ "ukYY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TOGGLE_SIDEBAR$REQUE;

var _constants = __webpack_require__("8x0Q");

var _mutationTypes = __webpack_require__("Du/2");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_TOGGLE_SIDEBAR$REQUE = {}, _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.TOGGLE_SIDEBAR, function (state) {
  state.sidebarVisible = !state.sidebarVisible;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_INVITE_INFO, function (state) {
  state.invite.loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_INVITE_INFO, function (state, payload) {
  state.invite.loading = false;
  state.invite.url = payload.invite_info.invite_url;
  state.invite.qrcode = payload.invite_info.qr_code;
  state.invite.reportqrcodes = payload.invite_info.report_qr_codes || [];
  state.invite.reporturls = payload.invite_info.report_urls || [];
  state.invite.home_page_url = payload.invite_info.home_page_url;

  state.invite.is_apply_sub_domain = !!payload.sub_domain;
  if (state.invite.is_apply_sub_domain) {
    state.invite.sub_domain_name = payload.sub_domain.name;
    state.invite.sub_domain_status = payload.sub_domain.status;
  }

  state.invite.is_apply_own_domain = !!payload.own_domain;
  if (state.invite.is_apply_own_domain) {
    state.invite.own_domain_name = payload.own_domain.domain_name;
    state.invite.own_domain_status = payload.own_domain.status;
  }
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SP_INFO, function (state) {
  state.info.loading = true;
  state.info.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SP_INFO, function (state, payload) {
  state.info.loading = false;
  state.info.saving = false;

  state.info.name = payload.name;
  state.info.contactor = payload.contactor;
  state.info.bind_sys_code = payload.bind_sys_code;
  state.info.yhl_team_name = payload.yhl_team_name;
  state.info.yhl_team_id = payload.yhl_team_id;
  state.info.yhl_branch_id = payload.yhl_branch_id;
  state.info.contact_phone = payload.contact_phone;
  state.info.address = payload.address;
  state.info.email = payload.email;
  state.info.about_content = payload.about_content;
  state.info.logo = payload.logo;
  state.info.sub_domain = payload.sub_domain;
  state.info.spec = payload.spec;
  state.info.login_account = payload.login_account;
  state.info.active_edition = _constants.APP_EDITIONS[payload.spec];
  state.info.use_we_chat_third_party_platform = payload.use_we_chat_third_party_platform;

  var expire_date = new Date(payload.expire_date),
      now = new Date(),
      millisecondsPerDay = 1000 * 60 * 60 * 24,
      millisBetween = expire_date.getTime() - now.getTime(),
      left_days = millisBetween / millisecondsPerDay;

  state.info.expire_date = expire_date;
  state.info.left_days = left_days;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SAVE_SP_INFO, function (state) {
  state.info.loading = false;
  state.info.saving = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SAVE_SP_INFO, function (state, payload) {
  state.info.loading = false;
  state.info.saving = false;

  state.info.name = payload.name;
  state.info.contactor = payload.contactor;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.UPDATE_INFO_CONTACTOR, function (state, value) {
  state.info.contactor = value;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.UPDATE_INFO_NAME, function (state, value) {
  state.info.name = value;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.UPDATE_WECHAT_APP_ID, function (state, value) {
  state.wechat.app_id = value;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.UPDATE_WECHAT_APP_SECRET, function (state, value) {
  state.wechat.app_secret = value;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.UPDATE_WECHAT_ENCODING_AES_KEY, function (state, value) {
  state.wechat.encoding_aes_key = value;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_WECHAT_INFO, function (state) {
  state.wechat.loading = true;
  state.wechat.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_WECHAT_CLEAR_SETTING, function (state) {
  state.wechat.loading = false;
  state.wechat.saving = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_WECHAT_INFO, function (state, payload) {
  state.wechat.loading = false;
  state.wechat.saving = false;

  state.wechat.is_empty = payload === null;

  if (payload !== null) {
    state.wechat.app_id = payload.app_id;
    state.wechat.app_secret = payload.app_secret;
    state.wechat.encoding_aes_key = payload.encoding_aes_key;
    state.wechat.token = payload.token;
    state.wechat.server_ip = payload.server_ip;
    state.wechat.callback_url = payload.callback_url;
    state.wechat.verified_domain = payload.verified_domain;
    state.wechat.qr_code = payload.qr_code;
    state.wechat.is_template_message_enabled = payload.is_template_message_enabled;
    state.wechat.ticket_progress_changed_template_id = payload.ticket_progress_changed_template_id;
    state.wechat.transfer_message_to_kf_system = payload.transfer_message_to_kf_system;
  }
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_WECHAT_CLEAR_SETTING, function (state) {
  state.wechat.loading = false;
  state.wechat.saving = false;

  state.wechat.app_id = '';
  state.wechat.app_secret = '';
  state.wechat.encoding_aes_key = '';
  state.wechat.token = '';
  state.wechat.server_ip = '';
  state.wechat.callback_url = '';
  state.wechat.verified_domain = '';
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SAVE_WECHAT_INFO, function (state) {
  state.wechat.loading = false;
  state.wechat.saving = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SAVE_WECHAT_INFO, function (state) {
  state.wechat.loading = false;
  state.wechat.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SAVE_FORM_INFO, function (state) {
  state.form.loading = false;
  state.form.saving = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SAVE_FORM_INFO, function (state) {
  state.form.loading = false;
  state.form.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_FORM_LIST, function (state) {
  state.form.loading = true;
  state.form.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_FORM_LIST, function (state, payload) {
  state.form.loading = false;
  state.form.saving = false;
  state.form.list = payload.collection;
  state.form.total = payload.total_records;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SHARED_FORM_LIST, function (state) {
  state.form.loading = true;
  state.form.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SHARED_FORM_LIST, function (state, payload) {
  state.form.loading = false;
  state.form.saving = false;
  state.form.shared_list = payload.collection;
  state.form.shared_total = payload.total_records;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_FORM_INFO, function (state) {
  state.form.loading = true;
  state.form.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_FORM_INFO, function (state, payload) {
  state.form.loading = false;
  state.form.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_DEFAULT_FORM_INFO, function (state) {
  state.form.df_loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_DEFAULT_FORM_INFO, function (state, payload) {
  state.form.df_loading = false;
  state.form.df = payload;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_MY_TICKET_LIST, function (state) {
  state.report_list.loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_MY_TICKET_LIST, function (state, payload) {
  state.report_list.loading = false;
  state.report_list.columns = payload.column_map;
  state.report_list.data = payload.collection;
  state.report_list.total = payload.total_records;
  state.report_list.additional_parameters = payload.additional_parameters || {};
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_TICKET_DETAIL, function (state) {
  state.report_detail.loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_TICKET_DETAIL, function (state, payload) {
  state.report_detail.loading = false;
  state.report_detail.ticket = payload.html;
  state.report_detail.no = payload.no;
  state.report_detail.videos = payload.videos;
  state.report_detail.voices = payload.voices;
  state.report_detail.attachments = payload.attachments;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_CHANGE_PASSWORD, function (state) {
  state.info.saving = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_CHANGE_PASSWORD, function (state) {
  state.info.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_CREATE_WECHAT_MENU, function (state) {
  state.wechat_menu.loading = false;
  state.wechat_menu.saving = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_CREATE_WECHAT_MENU, function (state) {
  state.wechat_menu.loading = false;
  state.wechat_menu.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_BIND_YHL_TEAM, function (state) {
  state.info.saving = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_BIND_YHL_TEAM, function (state) {
  state.info.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_APPLY_SUB_DOMAIN, function (state) {
  state.invite.loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_APPLY_SUB_DOMAIN, function (state) {
  state.invite.loading = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SUBDOMAIN_LIST, function (state) {
  state.sub_domain_list.loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SUBDOMAIN_LIST, function (state, payload) {
  state.sub_domain_list.loading = false;
  state.sub_domain_list.data = payload.collection;
  state.sub_domain_list.total = payload.total_records;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_ACCOUNT_INFO, function (state) {
  state.account_info.loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_ACCOUNT_INFO, function (state, payload) {
  state.account_info.loading = false;
  state.account_info.spec = payload.spec;
  state.account_info.can_renew_service = payload.spec > 0;
  state.account_info.can_upgrade_edition = payload.spec < 2;
  state.account_info.active_edition = _constants.APP_EDITIONS[payload.spec];

  var expire_date = new Date(payload.expire_date),
      now = new Date(),
      millisecondsPerDay = 1000 * 60 * 60 * 24,
      millisBetween = expire_date.getTime() - now.getTime(),
      left_days = millisBetween / millisecondsPerDay;

  state.account_info.expire_date = expire_date;
  state.account_info.left_days = left_days;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_ACCOUNT_RENEW, function (state) {}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_ACCOUNT_RENEW, function (state, payload) {}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_ACCOUNT_SZ_LIST, function (state) {
  state.account_info.list_loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_ACCOUNT_SZ_LIST, function (state, payload) {
  state.account_info.list_loading = false;
  state.account_info.list_data = payload.collection;
  state.account_info.list_total = payload.total_records;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SP_LIST, function (state) {
  state.sp_list.loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SP_LIST, function (state, payload) {
  state.sp_list.loading = false;
  state.sp_list.data = payload.collection;
  state.sp_list.total = payload.total_records;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_FETCH_WECHAT_MENU, function (state) {
  state.wechat_menu.loading = true;
  state.wechat_menu.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_FETCH_WECHAT_MENU, function (state, payload) {
  state.wechat_menu.loading = false;
  state.wechat_menu.saving = false;
  state.wechat_menu.menu = payload;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SP_SETTING, function (state) {
  state.setting.loading = true;
  state.setting.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SP_SETTING, function (state, payload) {
  state.setting.loading = false;
  state.setting.saving = false;
  state.setting.setting = payload;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SAVE_SP_SETTING, function (state) {
  state.setting.loading = false;
  state.setting.saving = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SAVE_SP_SETTING, function (state) {
  state.setting.loading = false;
  state.setting.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_FETCH_AUTHORIZER_LIST, function (state) {
  state.wechat_menu.loading = true;
  state.wechat_menu.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_FETCH_AUTHORIZER_LIST, function (state, payload) {
  state.wechat_menu.loading = false;
  state.wechat_menu.saving = false;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_SERVICE_TICKET_DETAIL, function (state) {
  state.report_detail.loading = true;
  state.report_detail.service_ticket_loaded = false;
  state.report_detail.service_ticket = null;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_SERVICE_TICKET_DETAIL, function (state, payload) {
  state.report_detail.loading = false;
  state.report_detail.service_ticket_loaded = true;
  state.report_detail.service_ticket = payload;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_FETCH_TICKET_STEPS, function (state) {
  state.report_steps.querying = true;
  state.report_steps.steps = [];
  state.report_steps.current = 0;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_FETCH_TICKET_STEPS, function (state, payload) {
  state.report_steps.querying = false;
  if (payload) {
    state.report_steps.steps = payload.steps;
    state.report_steps.current = payload.current_step;
  }
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.REQUEST_RM_LIST, function (state) {
  state.repair_member_list.loading = true;
}), _defineProperty(_TOGGLE_SIDEBAR$REQUE, _mutationTypes.RECEIVE_RM_LIST, function (state, payload) {
  state.repair_member_list.loading = false;
  state.repair_member_list.data = payload.collection;
  state.repair_member_list.total = payload.total_records;
}), _TOGGLE_SIDEBAR$REQUE);

/***/ }),

/***/ "v1bw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vuex = __webpack_require__("SJI6");

var _navigationTrigger = __webpack_require__("Owz1");

var _navigationTrigger2 = _interopRequireDefault(_navigationTrigger);

var _auth = __webpack_require__("TIfe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { NavigationTrigger: _navigationTrigger2.default },
  data: function data() {
    return {
      show_reminder_popover: false,
      show_reminder_alarm: false
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(['info_active_edition', 'info_expire_date', 'info_left_days', 'info_spec']), {
    renew_or_upgrade_text: {
      get: function get() {
        return this.info_spec === 0 ? '升级版本' : '续费';
      }
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(['fetchSpInfo']), {
    logout_session: function logout_session() {
      (0, _auth.logout)();
    }
  }),
  beforeCreated: function beforeCreated() {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.fetchSpInfo().then(function () {
      _this.show_reminder_alarm = _this.show_reminder_popover = _this.info_left_days <= 10;
    }).catch(function () {});
  }
};

/***/ }),

/***/ "xubR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zU0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('NavigationTrigger'),_vm._v(" "),_c('div',{staticClass:"header__logo"},[_c('h1',[_c('router-link',{attrs:{"to":{ name: 'Dashboard', params: {}}}},[_vm._v("乐报修服务商后台")])],1)]),_vm._v(" "),_c('ul',{staticClass:"top-nav"},[_c('el-popover',{ref:"popover2",attrs:{"placement":"bottom","title":"您的服务即将到期","width":"300","trigger":"click"},model:{value:(_vm.show_reminder_popover),callback:function ($$v) {_vm.show_reminder_popover=$$v},expression:"show_reminder_popover"}},[_c('p',[_vm._v("\n        您正在使用 "),_c('el-tag',{domProps:{"textContent":_vm._s(_vm.info_active_edition)}}),_vm._v(" 服务"),_c('br'),_vm._v("\n        该服务将于 "),_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.info_expire_date)))]),_vm._v(" 到期, 是否现在"+_vm._s(_vm.renew_or_upgrade_text)+"？\n      ")],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"size":"mini","type":"text"},on:{"click":function($event){_vm.show_reminder_popover = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){_vm.show_reminder_popover = false;_vm.$router.push({name: 'AccountInfo', params: {}});}}},[_vm._v("确定\n        ")])],1)]),_vm._v(" "),(_vm.show_reminder_alarm)?_c('li',{on:{"click":function($event){_vm.show_reminder_popover = true}}},[_c('a',{directives:[{name:"popover",rawName:"v-popover:popover2",arg:"popover2"}],staticClass:"top-nav__notify"},[_c('i',{staticClass:"zmdi zmdi-notifications text-warning"})])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"hidden-xs-down"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout_session}},[_c('i',{staticClass:"zmdi zmdi-power"})])])],1)],1)}
var staticRenderFns = []


/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.9649c5c032d2f56546b8.js